/**
 * Copyright (c) 2026, CheckPlus Limited
 */
// Hong Kong address structure data
// Based on Hong Kong Post's structured addressing format — 118 sub-districts

const hkRegions = [
  {
    id: 'hk',
    name_en: 'HONG KONG',
    name_tc: '香港',
    districts: [
      { id: 'aberdeen', name_en: 'ABERDEEN', name_tc: '香港仔' },
      { id: 'admiralty', name_en: 'ADMIRALTY', name_tc: '金鐘' },
      { id: 'ap_lei_chau', name_en: 'AP LEI CHAU', name_tc: '鴨脷洲' },
      { id: 'causeway_bay', name_en: 'CAUSEWAY BAY', name_tc: '銅鑼灣' },
      { id: 'central', name_en: 'CENTRAL', name_tc: '中環' },
      { id: 'chai_wan', name_en: 'CHAI WAN', name_tc: '柴灣' },
      { id: 'chung_hom_kok', name_en: 'CHUNG HOM KOK', name_tc: '舂坎角' },
      { id: 'deep_water_bay', name_en: 'DEEP WATER BAY', name_tc: '深水灣' },
      { id: 'happy_valley', name_en: 'HAPPY VALLEY', name_tc: '跑馬地' },
      { id: 'kennedy_town', name_en: 'KENNEDY TOWN', name_tc: '堅尼地城' },
      { id: 'mid_levels', name_en: 'MID-LEVELS', name_tc: '半山區' },
      { id: 'north_point', name_en: 'NORTH POINT', name_tc: '北角' },
      { id: 'pok_fu_lam', name_en: 'POK FU LAM', name_tc: '薄扶林' },
      { id: 'quarry_bay', name_en: 'QUARRY BAY', name_tc: '鰂魚涌' },
      { id: 'repulse_bay', name_en: 'REPULSE BAY', name_tc: '淺水灣' },
      { id: 'sai_wan_ho', name_en: 'SAI WAN HO', name_tc: '西灣河' },
      { id: 'sai_ying_pun', name_en: 'SAI YING PUN', name_tc: '西營盤' },
      { id: 'shau_kei_wan', name_en: 'SHAU KEI WAN', name_tc: '筲箕灣' },
      { id: 'shek_o', name_en: 'SHEK O', name_tc: '石澳' },
      { id: 'shek_tong_tsui', name_en: 'SHEK TONG TSUI', name_tc: '石塘咀' },
      { id: 'sheung_wan', name_en: 'SHEUNG WAN', name_tc: '上環' },
      { id: 'stanley', name_en: 'STANLEY', name_tc: '赤柱' },
      { id: 'tai_hang', name_en: 'TAI HANG', name_tc: '大坑' },
      { id: 'tai_tam', name_en: 'TAI TAM', name_tc: '大潭' },
      { id: 'the_peak', name_en: 'THE PEAK', name_tc: '山頂' },
      { id: 'wan_chai', name_en: 'WAN CHAI', name_tc: '灣仔' },
      { id: 'wong_chuk_hang', name_en: 'WONG CHUK HANG', name_tc: '黃竹坑' },
    ],
  },
  {
    id: 'kln',
    name_en: 'KOWLOON',
    name_tc: '九龍',
    districts: [
      { id: 'cha_kwo_ling', name_en: 'CHA KWO LING', name_tc: '茶果嶺' },
      { id: 'cheung_sha_wan', name_en: 'CHEUNG SHA WAN', name_tc: '長沙灣' },
      { id: 'diamond_hill', name_en: 'DIAMOND HILL', name_tc: '鑽石山' },
      { id: 'ho_man_tin', name_en: 'HO MAN TIN', name_tc: '何文田' },
      { id: 'hung_hom', name_en: 'HUNG HOM', name_tc: '紅磡' },
      { id: 'kai_tak', name_en: 'KAI TAK', name_tc: '啟德' },
      { id: 'kowloon_bay', name_en: 'KOWLOON BAY', name_tc: '九龍灣' },
      { id: 'kowloon_city', name_en: 'KOWLOON CITY', name_tc: '九龍城' },
      { id: 'kowloon_tong', name_en: 'KOWLOON TONG', name_tc: '九龍塘' },
      { id: 'kwun_tong', name_en: 'KWUN TONG', name_tc: '觀塘' },
      { id: 'lai_chi_kok', name_en: 'LAI CHI KOK', name_tc: '荔枝角' },
      { id: 'lam_tin', name_en: 'LAM TIN', name_tc: '藍田' },
      { id: 'lok_fu', name_en: 'LOK FU', name_tc: '樂富' },
      { id: 'mong_kok', name_en: 'MONG KOK', name_tc: '旺角' },
      { id: 'ngau_chi_wan', name_en: 'NGAU CHI WAN', name_tc: '牛池灣' },
      { id: 'ngau_tau_kok', name_en: 'NGAU TAU KOK', name_tc: '牛頭角' },
      { id: 'san_po_kong', name_en: 'SAN PO KONG', name_tc: '新蒲崗' },
      { id: 'sau_mau_ping', name_en: 'SAU MAU PING', name_tc: '秀茂坪' },
      { id: 'sham_shui_po', name_en: 'SHAM SHUI PO', name_tc: '深水埗' },
      { id: 'shek_kip_mei', name_en: 'SHEK KIP MEI', name_tc: '石硤尾' },
      { id: 'tai_kok_tsui', name_en: 'TAI KOK TSUI', name_tc: '大角咀' },
      { id: 'to_kwa_wan', name_en: 'TO KWA WAN', name_tc: '土瓜灣' },
      { id: 'tsim_sha_tsui', name_en: 'TSIM SHA TSUI', name_tc: '尖沙咀' },
      { id: 'tsz_wan_shan', name_en: 'TSZ WAN SHAN', name_tc: '慈雲山' },
      { id: 'wang_tau_hom', name_en: 'WANG TAU HOM', name_tc: '橫頭磡' },
      { id: 'wong_tai_sin', name_en: 'WONG TAI SIN', name_tc: '黃大仙' },
      { id: 'yau_ma_tei', name_en: 'YAU MA TEI', name_tc: '油麻地' },
      { id: 'yau_tong', name_en: 'YAU TONG', name_tc: '油塘' },
      { id: 'yau_yat_chuen', name_en: 'YAU YAT CHUEN', name_tc: '又一村' },
    ],
  },
  {
    id: 'nt',
    name_en: 'NEW TERRITORIES',
    name_tc: '新界',
    districts: [
      { id: 'cheung_chau', name_en: 'CHEUNG CHAU', name_tc: '長洲' },
      { id: 'clear_water_bay', name_en: 'CLEAR WATER BAY', name_tc: '清水灣' },
      { id: 'crooked_island', name_en: 'CROOKED ISLAND', name_tc: '吉澳' },
      { id: 'fanling', name_en: 'FANLING', name_tc: '粉嶺' },
      { id: 'fanling_kwan_tei', name_en: 'FANLING - KWAN TEI', name_tc: '粉嶺軍地' },
      { id: 'grass_island', name_en: 'GRASS ISLAND', name_tc: '塔門' },
      { id: 'hei_ling_chau', name_en: 'HEI LING CHAU', name_tc: '喜靈洲' },
      { id: 'hung_shui_kiu', name_en: 'HUNG SHUI KIU', name_tc: '洪水橋' },
      { id: 'kwai_chung', name_en: 'KWAI CHUNG', name_tc: '葵涌' },
      { id: 'kwu_tung', name_en: 'KWU TUNG', name_tc: '古洞' },
      { id: 'lamma_island', name_en: 'LAMMA ISLAND', name_tc: '南丫島' },
      { id: 'lantau_island', name_en: 'LANTAU ISLAND', name_tc: '大嶼山' },
      { id: 'lantau_chek_lap_kok', name_en: 'LANTAU ISLAND - CHEK LAP KOK', name_tc: '大嶼山赤鱲角' },
      { id: 'lantau_cheung_sha', name_en: 'LANTAU ISLAND - CHEUNG SHA', name_tc: '大嶼山長沙' },
      { id: 'lantau_chi_ma_wan', name_en: 'LANTAU ISLAND - CHI MA WAN', name_tc: '大嶼山芝麻灣' },
      { id: 'lantau_discovery_bay', name_en: 'LANTAU ISLAND - DISCOVERY BAY', name_tc: '大嶼山愉景灣' },
      { id: 'lantau_mui_wo', name_en: 'LANTAU ISLAND - MUI WO', name_tc: '大嶼山梅窩' },
      { id: 'lantau_ngong_ping', name_en: 'LANTAU ISLAND - NGONG PING', name_tc: '大嶼山昂坪' },
      { id: 'lantau_shek_pik', name_en: 'LANTAU ISLAND - SHEK PIK', name_tc: '大嶼山石壁' },
      { id: 'lantau_tai_o', name_en: 'LANTAU ISLAND - TAI O', name_tc: '大嶼山大澳' },
      { id: 'lantau_tong_fuk', name_en: 'LANTAU ISLAND - TONG FUK', name_tc: '大嶼山塘福' },
      { id: 'lantau_tung_chung', name_en: 'LANTAU ISLAND - TUNG CHUNG', name_tc: '大嶼山東涌' },
      { id: 'lau_fau_shan', name_en: 'LAU FAU SHAN', name_tc: '流浮山' },
      { id: 'ma_on_shan', name_en: 'MA ON SHAN', name_tc: '馬鞍山' },
      { id: 'ma_wan', name_en: 'MA WAN', name_tc: '馬灣' },
      { id: 'peng_chau', name_en: 'PENG CHAU', name_tc: '坪洲' },
      { id: 'ping_che', name_en: 'PING CHE', name_tc: '坪輋' },
      { id: 'sai_kung', name_en: 'SAI KUNG', name_tc: '西貢' },
      { id: 'sha_tau_kok', name_en: 'SHA TAU KOK', name_tc: '沙頭角' },
      { id: 'sha_tin', name_en: 'SHA TIN', name_tc: '沙田' },
      { id: 'sha_tin_fo_tan', name_en: 'SHA TIN - FO TAN', name_tc: '沙田火炭' },
      { id: 'sha_tin_siu_lek_yuen', name_en: 'SHA TIN - SIU LEK YUEN', name_tc: '沙田小瀝源' },
      { id: 'sha_tin_tai_wai', name_en: 'SHA TIN - TAI WAI', name_tc: '沙田大圍' },
      { id: 'sham_tseng', name_en: 'SHAM TSENG', name_tc: '深井' },
      { id: 'shek_kwu_chau', name_en: 'SHEK KWU CHAU', name_tc: '石鼓洲' },
      { id: 'sheung_shui', name_en: 'SHEUNG SHUI', name_tc: '上水' },
      { id: 'so_kwun_wat', name_en: 'SO KWUN WAT', name_tc: '掃管笏' },
      { id: 'ta_kwu_ling', name_en: 'TA KWU LING', name_tc: '打鼓嶺' },
      { id: 'tai_lam', name_en: 'TAI LAM', name_tc: '大欖' },
      { id: 'tai_po', name_en: 'TAI PO', name_tc: '大埔' },
      { id: 'tai_po_lam_tsuen', name_en: 'TAI PO - LAM TSUEN', name_tc: '大埔林村' },
      { id: 'tai_po_ting_kok', name_en: 'TAI PO - TING KOK', name_tc: '大埔汀角' },
      { id: 'tai_po_kau', name_en: 'TAI PO KAU', name_tc: '大埔滘' },
      { id: 'tin_shui_wai', name_en: 'TIN SHUI WAI', name_tc: '天水圍' },
      { id: 'ting_kau', name_en: 'TING KAU', name_tc: '汀九' },
      { id: 'tseung_kwan_o', name_en: 'TSEUNG KWAN O', name_tc: '將軍澳' },
      { id: 'tsing_yi', name_en: 'TSING YI', name_tc: '青衣' },
      { id: 'tsuen_wan', name_en: 'TSUEN WAN', name_tc: '荃灣' },
      { id: 'tuen_mun', name_en: 'TUEN MUN', name_tc: '屯門' },
      { id: 'tuen_mun_lam_tei', name_en: 'TUEN MUN - LAM TEI', name_tc: '屯門藍地' },
      { id: 'tuen_mun_siu_lam', name_en: 'TUEN MUN - SIU LAM', name_tc: '屯門小欖' },
      { id: 'yuen_long', name_en: 'YUEN LONG', name_tc: '元朗' },
      { id: 'yuen_long_kam_tin', name_en: 'YUEN LONG - KAM TIN', name_tc: '元朗錦田' },
      { id: 'yuen_long_pat_heung', name_en: 'YUEN LONG - PAT HEUNG', name_tc: '元朗八鄉' },
      { id: 'yuen_long_ping_shan', name_en: 'YUEN LONG - PING SHAN', name_tc: '元朗屏山' },
      { id: 'yuen_long_san_tin', name_en: 'YUEN LONG - SAN TIN', name_tc: '元朗新田' },
      { id: 'yuen_long_shek_kong', name_en: 'YUEN LONG - SHEK KONG', name_tc: '元朗石崗' },
      { id: 'yuen_long_tai_tong', name_en: 'YUEN LONG - TAI TONG', name_tc: '元朗大棠' },
      { id: 'yuen_long_tam_mei', name_en: 'YUEN LONG - TAM MEI', name_tc: '元朗潭尾' },
    ],
  },
];

/**
 * Get districts for a given region ID
 */
export function getDistrictsByRegion(regionId) {
  const region = hkRegions.find(r => r.id === regionId);
  return region ? region.districts : [];
}

/**
 * Get the region/district label based on language
 */
export function getLabel(item, language) {
  if (language === 'zh' || language === 'cn') {
    return item.name_tc || item.name_en;
  }
  return item.name_en;
}

export const countryList = [
  { value: 'Hong Kong', name_en: 'Hong Kong', name_tc: '香港' },
  { value: 'Afghanistan', name_en: 'Afghanistan', name_tc: '阿富汗' },
  { value: 'Albania', name_en: 'Albania', name_tc: '阿爾巴尼亞' },
  { value: 'Algeria', name_en: 'Algeria', name_tc: '阿爾及利亞' },
  { value: 'Argentina', name_en: 'Argentina', name_tc: '阿根廷' },
  { value: 'Australia', name_en: 'Australia', name_tc: '澳洲' },
  { value: 'Austria', name_en: 'Austria', name_tc: '奧地利' },
  { value: 'Bangladesh', name_en: 'Bangladesh', name_tc: '孟加拉' },
  { value: 'Belgium', name_en: 'Belgium', name_tc: '比利時' },
  { value: 'Brazil', name_en: 'Brazil', name_tc: '巴西' },
  { value: 'Cambodia', name_en: 'Cambodia', name_tc: '柬埔寨' },
  { value: 'Canada', name_en: 'Canada', name_tc: '加拿大' },
  { value: 'Chile', name_en: 'Chile', name_tc: '智利' },
  { value: 'China', name_en: 'China', name_tc: '中國' },
  { value: 'Colombia', name_en: 'Colombia', name_tc: '哥倫比亞' },
  { value: 'Czech Republic', name_en: 'Czech Republic', name_tc: '捷克' },
  { value: 'Denmark', name_en: 'Denmark', name_tc: '丹麥' },
  { value: 'Egypt', name_en: 'Egypt', name_tc: '埃及' },
  { value: 'Finland', name_en: 'Finland', name_tc: '芬蘭' },
  { value: 'France', name_en: 'France', name_tc: '法國' },
  { value: 'Germany', name_en: 'Germany', name_tc: '德國' },
  { value: 'Greece', name_en: 'Greece', name_tc: '希臘' },
  { value: 'India', name_en: 'India', name_tc: '印度' },
  { value: 'Indonesia', name_en: 'Indonesia', name_tc: '印尼' },
  { value: 'Ireland', name_en: 'Ireland', name_tc: '愛爾蘭' },
  { value: 'Israel', name_en: 'Israel', name_tc: '以色列' },
  { value: 'Italy', name_en: 'Italy', name_tc: '意大利' },
  { value: 'Japan', name_en: 'Japan', name_tc: '日本' },
  { value: 'Kenya', name_en: 'Kenya', name_tc: '肯尼亞' },
  { value: 'Macau', name_en: 'Macau', name_tc: '澳門' },
  { value: 'Malaysia', name_en: 'Malaysia', name_tc: '馬來西亞' },
  { value: 'Mexico', name_en: 'Mexico', name_tc: '墨西哥' },
  { value: 'Netherlands', name_en: 'Netherlands', name_tc: '荷蘭' },
  { value: 'New Zealand', name_en: 'New Zealand', name_tc: '紐西蘭' },
  { value: 'Nigeria', name_en: 'Nigeria', name_tc: '尼日利亞' },
  { value: 'Norway', name_en: 'Norway', name_tc: '挪威' },
  { value: 'Pakistan', name_en: 'Pakistan', name_tc: '巴基斯坦' },
  { value: 'Philippines', name_en: 'Philippines', name_tc: '菲律賓' },
  { value: 'Poland', name_en: 'Poland', name_tc: '波蘭' },
  { value: 'Portugal', name_en: 'Portugal', name_tc: '葡萄牙' },
  { value: 'Russia', name_en: 'Russia', name_tc: '俄羅斯' },
  { value: 'Saudi Arabia', name_en: 'Saudi Arabia', name_tc: '沙特阿拉伯' },
  { value: 'Singapore', name_en: 'Singapore', name_tc: '新加坡' },
  { value: 'South Africa', name_en: 'South Africa', name_tc: '南非' },
  { value: 'South Korea', name_en: 'South Korea', name_tc: '韓國' },
  { value: 'Spain', name_en: 'Spain', name_tc: '西班牙' },
  { value: 'Sweden', name_en: 'Sweden', name_tc: '瑞典' },
  { value: 'Switzerland', name_en: 'Switzerland', name_tc: '瑞士' },
  { value: 'Taiwan', name_en: 'Taiwan', name_tc: '台灣' },
  { value: 'Thailand', name_en: 'Thailand', name_tc: '泰國' },
  { value: 'Turkey', name_en: 'Turkey', name_tc: '土耳其' },
  { value: 'UAE', name_en: 'UAE', name_tc: '阿聯酋' },
  { value: 'United Kingdom', name_en: 'United Kingdom', name_tc: '英國' },
  { value: 'United States', name_en: 'United States', name_tc: '美國' },
  { value: 'Vietnam', name_en: 'Vietnam', name_tc: '越南' },
  { value: 'Other', name_en: 'Other', name_tc: '其他' },
];

export default hkRegions;
